import { getField, updateField } from 'vuex-map-fields'
import getWorkflowDashboardFiltersModel from './models/workflowDashboardFilters'

const workflowDashboardFilters = {
  namespaced: true,
  state: {
    ...getWorkflowDashboardFiltersModel()
  },
  getters: {
    getField,
    getSearchObject (state) {
      return state
    }
  },
  actions: {
    clearFilters ({ commit }) {
      return commit('clearFilters')
    }
  },
  mutations: {
    updateField,
    clearFilters (state) {
      const defaults = getWorkflowDashboardFiltersModel()
      Object.keys(defaults).forEach(key => { state[key] = defaults[key] })
    }
  }
}

export default workflowDashboardFilters
